module.exports = __webpack_public_path__ + "img/logo.cfd744ab.png";